import React from 'react'

const LoginMessageShowing = () => {
    return (
        <div>
            Login to Continue
        </div>
    )
}

export default LoginMessageShowing
